import _ from "lodash";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchOrders,
  fetchLineItems,
  openModal,
  fetchAdData,
  fetchAdRequest,
} from "../actions";
import { Table, Header, Pagination, Button, Dropdown } from "semantic-ui-react";
import { ApiRequest } from "../firebase/server";

const options = [
  { key: 10, text: "10 per page", value: 10 },
  { key: 50, text: "50 per page", value: 50 },
  { key: 100, text: "100 per page", value: 100 },
];

//const getTrigger = (error) => {
//  return typeof error.trigger === "object"
//    ? error.fieldPathElements[2].field
//    : error.trigger;
//};

//const reasonMaker = (errors) => {
//  let trigger, reason;
//
//  if (errors.length) {
//    if (errors.length > 1) {
//      errors.forEach((error) => {
//        trigger = getTrigger(error);
//        reason += `${error.fieldPathElements[1].field}: ${trigger} ${error.reason}, `;
//      });
//    }
//  } else if (errors.fieldPathElements[1]) {
//    trigger = getTrigger(errors);
//    reason = `${errors.fieldPathElements[1].field}: ${trigger} ${errors.reason}`;
//  }
//
//  if (trigger) return reason;
//  return `${errors.errorString}`;
//};

const makeUnique = (data) => {
  let uniq = _.uniqBy(data, "lineItemId");
  uniq.forEach((obj) => {
    obj.cids = [];
  });
  data.forEach((item) => {
    uniq.forEach((i) => {
      if (item.lineItemId === i.lineItemId) {
        i.cids.push(item.creativeId);
      }
    });
  });
  return uniq;
};

const Orders = ({ orders, advertiser, adRequest }) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeOrder, setActiveOrder] = useState();

  const [pageBy, setPageBy] = useState(10);
  const pages = orders ? Math.ceil(orders.length / pageBy) : 0;
  const start = (currentPage - 1) * pageBy;
  const list = _.slice(orders, start, start + pageBy);

  const handlePageChange = (event, data) => {
    setCurrentPage(data.activePage);
  };

  const handleNext = (event) => {
    const message = `Finding line items for ${activeOrder.orderName}`;

    dispatch(fetchOrders([]));

    dispatch(
      openModal("LoadingModal", {
        centered: false,
        title: message,
      })
    );

    const request = {
      retailer: adRequest.retailer,
      service: adRequest.service,
      call: "getLineItems",
      orderId: activeOrder.orderId,
      orderName: activeOrder.orderName,
    };

    dispatch(fetchAdRequest(request));

    ApiRequest(request).then(
      (results) => {
        dispatch(fetchLineItems(results.result.rval.results));
        dispatch(openModal("AdDataModal", { centered: false }));
      },
      (error) => {
        console.log(error);
        dispatch(
          openModal("ErrorModal", {
            centered: false,
            type: "negative",
            error: {
              name: message,
              error: `Google Ad Manager error: ${error.message}`,
            },
          })
        );
      }
    );
  };

  return (
    <>
      <Header as="h3">Finding orders for {advertiser}</Header>
      <Table selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Order id</Table.HeaderCell>
            <Table.HeaderCell>Order name</Table.HeaderCell>
            <Table.HeaderCell>Start date</Table.HeaderCell>
            <Table.HeaderCell>End date</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {list.length > 0 ? (
            _.map(list, (order) => (
              <Table.Row
                key={order.id}
                positive={activeOrder && order.id === activeOrder.orderId}
                onClick={() =>
                  setActiveOrder({ orderId: order.id, orderName: order.name })
                }
              >
                <Table.Cell>{order.id}</Table.Cell>
                <Table.Cell>{order.name}</Table.Cell>
                <Table.Cell>
                  {`${order.startDateTime.date.day}/${order.startDateTime.date.month}/${order.startDateTime.date.year}`}
                </Table.Cell>
                <Table.Cell>
                  {order.endDateTime &&
                    `${order.endDateTime.date.day}/${order.endDateTime.date.month}/${order.endDateTime.date.year}`}
                </Table.Cell>
                <Table.Cell>{order.status}</Table.Cell>
              </Table.Row>
            ))
          ) : (
            <Table.Row>
              <Table.Cell colSpan="5">
                {`Sorry, no results for ${advertiser}`}
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="5">
              <Button
                size="mini"
                positive
                disabled={!activeOrder}
                onClick={handleNext}
              >
                Next
              </Button>
              <div style={{ float: "right", display: "flex", gap: "10px", alignItems: "center" }}>
                {(orders && (orders.length > 10 || pageBy > 10)) && (
                  <Dropdown
                    compact
                    selection
                    options={options}
                    value={pageBy}
                    onChange={(e, { value }) => {
                      setPageBy(value);
                      setCurrentPage(1);
                    }}
                  />
                )}
                {orders && orders.length > pageBy && (
                  <Pagination
                    boundaryRange={0}
                    totalPages={pages}
                    onPageChange={handlePageChange}
                    activePage={currentPage}
                    size="mini"
                  />
                )}
              </div>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};

const LineItems = ({ lineItems, adNumber, adRequest }) => {
  lineItems = lineItems || [];

  const dispatch = useDispatch();

  const banner = useSelector((state) => state.banner);
  const advertisers = useSelector((state) => state.advertisers);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeLineItems, setActiveLineItems] = useState([]);
  const [pageBy, setPageBy] = useState(10);
  const pages = Math.ceil(lineItems.length / pageBy);
  const start = (currentPage - 1) * pageBy;
  const list = _.slice(lineItems, start, start + pageBy);

  const handlePageChange = (event, data) => {
    setCurrentPage(data.activePage);
  };

  const toggleSelect = (event, li) => {
    let target = event.currentTarget;

    const found = _.find(activeLineItems, (item) => {
      return item.id === li.id;
    });
    if (found) {
      if (found.id === li.id) {
        setActiveLineItems(activeLineItems.filter((ai) => ai.id !== li.id));
        target.classList.remove("positive");
      }
    } else {
      setActiveLineItems([...activeLineItems, li]);
      target.classList.add("positive");
    }
  };

  const getAdvertiserById = (id) => {
    if (id) {
      let index = _.findIndex(advertisers, (adv) => {
        return adv.advertiserId === id;
      });
      return index !== -1 ? advertisers[index].displayName : "UNKNOWN";
    }
  };

  const handleUpload = () => {
    const c = window.confirm(
      "Please confirm you want to upload this banner to the selected line item(s)"
    );
    if (c) {
      const request = {
        retailer: adRequest.retailer,
        service: adRequest.service,
        call: "uploadCreative",
        banner,
        lineItems: activeLineItems,
      };

      dispatch(fetchLineItems([]));

      dispatch(
        openModal("LoadingModal", {
          centered: false,
          title: `Uploading ${banner.bannerTitle}`,
        })
      );
      ApiRequest(request).then(
        (results) => {
          dispatch(fetchAdData(results.result));
          dispatch(openModal("AdDataModal", { centered: false }));
        },
        (error) => {
          //console.log("ApiRequest error", JSON.parse(JSON.stringify(error)));
          //console.log("ApiRequest error message", error.message);
          error = error.response || error.message;
          //console.log("response or message", JSON.parse(JSON.stringify(error)));
          //console.log("adData ApiRequest error", error);
          //let reason;
          //if (error.code) {
          //  if (error.code === "EPIPE") {
          //    reason = error.reason;
          //  }
          //}

          const { data } = error;
          const { message, reason } = data;
          //let dataMessage = data.message;

          //if (!dataMessage) {
          //  reason = data;
          //}
          //const msg = dataMessage || message || "";

          //if (dataMessage || message) {
          //  const errObj = JSON.parse(data.reason) || JSON.parse(error.reason);
          //  if (errObj) {
          //    if (errObj["HTML"]) {
          //      reason = errObj["HTML"]["HEAD"]["TITLE"];
          //    } else {
          //      const { errors } = errObj["soap:Envelope"]["soap:Body"][
          //        "soap:Fault"
          //      ].detail.ApiExceptionFault;
          //      reason = reasonMaker(errors);
          //    }
          //  }
          //}
          dispatch(
            openModal("ErrorModal", {
              centered: false,
              type: "negative",
              error: {
                name: `Uploading ${banner.bannerTitle}`,
                error: `Google Ad Manager error: ${message}`,
                reason,
              },
            })
          );
        }
      );
    }
  };

  return (
    <>
      <Header as="h3">
        Finding line items for{" "}
        {adRequest.orderName ? adRequest.orderName : adNumber}
      </Header>
      <Table selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Order id</Table.HeaderCell>
            <Table.HeaderCell>Line item id</Table.HeaderCell>
            <Table.HeaderCell>Line item name</Table.HeaderCell>
            <Table.HeaderCell>Start date</Table.HeaderCell>
            <Table.HeaderCell>End date</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Advertiser</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {list.length > 0 ? (
            _.map(list, (lineItem) => (
              <Table.Row
                key={lineItem.id}
                onClick={(e) => toggleSelect(e, lineItem)}
              >
                <Table.Cell>{lineItem.orderId}</Table.Cell>
                <Table.Cell>{lineItem.id}</Table.Cell>
                <Table.Cell className="break-all">{lineItem.name}</Table.Cell>
                <Table.Cell>
                  {`${lineItem.startDateTime.date.day}/${lineItem.startDateTime.date.month}/${lineItem.startDateTime.date.year}`}
                </Table.Cell>
                <Table.Cell>
                  {lineItem.endDateTime &&
                    `${lineItem.endDateTime.date.day}/${lineItem.endDateTime.date.month}/${lineItem.endDateTime.date.year}`}
                </Table.Cell>
                <Table.Cell>{lineItem.status}</Table.Cell>
                <Table.Cell>
                  {getAdvertiserById(lineItem.advertiserId)}
                </Table.Cell>
              </Table.Row>
            ))
          ) : (
            <Table.Row>
              <Table.Cell colSpan="7">
                Sorry, no results for{" "}
                {adRequest.orderName ? adRequest.orderName : adNumber}
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="7">
              <Button
                size="mini"
                positive
                disabled={activeLineItems.length < 1}
                onClick={handleUpload}
              >
                Upload banner
              </Button>
              <div style={{ float: "right", display: "flex", gap: "10px", alignItems: "center" }}>
                {(lineItems.length > 10 || pageBy > 10) && (
                  <Dropdown
                    compact
                    selection
                    options={options}
                    value={pageBy}
                    onChange={(e, { value }) => {
                      setPageBy(value);
                      setCurrentPage(1);
                    }}
                  />
                )}
                {lineItems.length > pageBy && (
                  <Pagination
                    boundaryRange={0}
                    totalPages={pages}
                    onPageChange={handlePageChange}
                    activePage={currentPage}
                    size="mini"
                  />
                )}
              </div>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};

export const AdServeData = ({ data }) => {
  const uniqueData = makeUnique(data);
  return (
    <div className="overflow-auto">
      <Table striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Order</Table.HeaderCell>
            <Table.HeaderCell>Order name</Table.HeaderCell>
            <Table.HeaderCell>Line item</Table.HeaderCell>
            <Table.HeaderCell>Line item name</Table.HeaderCell>
            <Table.HeaderCell>Creative(s)</Table.HeaderCell>
            <Table.HeaderCell>Audience id</Table.HeaderCell>
            <Table.HeaderCell>Start date</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {_.map(uniqueData, (item) => (
            <Table.Row key={`${item.lineItemId}${item.creativeId}`}>
              <Table.Cell>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://admanager.google.com/8326#delivery/OrderDetail/orderId=${item.orderId}`}
                >
                  {item.orderId}
                </a>
              </Table.Cell>
              <Table.Cell className="break-all">{item.orderName}</Table.Cell>
              <Table.Cell>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://admanager.google.com/8326#delivery/LineItemDetail/lineItemId=${item.lineItemId}`}
                >
                  {item.lineItemId}
                </a>
              </Table.Cell>
              <Table.Cell className="break-all">{item.lineItemName}</Table.Cell>
              <Table.Cell>
                {_.map(item.cids, (cid) => (
                  <span key={cid}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://admanager.google.com/8326#delivery/CreativeDetail/creativeId=${cid}`}
                    >
                      {cid}
                    </a>
                    {`, `}
                  </span>
                ))}
              </Table.Cell>
              <Table.Cell>
                {item.audienceIds && item.audienceIds.join(", ")}
              </Table.Cell>
              <Table.Cell>
                {`${item.startDateTime.date.day}/${item.startDateTime.date.month}/${item.startDateTime.date.year}`}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

const AdData = () => {
  const { data, type } = useSelector((state) => state.adData);
  const { advertiser, adNumber } = useSelector((state) => state.banner);
  const adRequest = useSelector((state) => state.adRequest);

  return (
    <>
      {type === "orders" && (
        <Orders orders={data} advertiser={advertiser} adRequest={adRequest} />
      )}
      {type === "lineItems" && (
        <LineItems lineItems={data} adNumber={adNumber} adRequest={adRequest} />
      )}
      {type === "adData" && <AdServeData data={data} />}
    </>
  );
};

export default AdData;
